/* eslint-disable max-classes-per-file */
import { ProduktionsmallQueryResponseDTO } from "~app/common/models/produktionsmall/v2/ProduktionsmallQueryResponseDTO";
import { ICommandManager } from "~app/common/services/cqs/commandManager";
import { UpdateProduktionsmallProduktinstruktionCommand } from "~app/features/planera/commands/UpdateProduktionsmallProduktinstruktionCommand";
import { IProduktvalRow, IProduktvalRowProduktInstruktion, ProduktvalRowBase } from "~app/features/planera/produktval/produktval.models";

export class ProduktionsmallProduktvalRow extends ProduktvalRowBase implements IProduktvalRow {
    collapsed: boolean;

    constructor(
        private readonly commandManager: ICommandManager,
        private readonly produktionsmallGuid: string) {
        super();
        this.produktinstruktioner = [];
        this.collapsed = true;
    }

    setJusteradKvantitet(newValue: number): void {
        // Not implemented
    }

    setMedTillUtbytessimulering(newValue: number): void {
        const prevValue = this.medTillUtbytessimulering;
        if (prevValue && this.produktId) {
            // prev is no longer medIUtbytessimulering
            const cmd = new UpdateProduktionsmallProduktinstruktionCommand(this.produktionsmallGuid, this.handelssortimentId, this.produktId, prevValue);
            cmd.medIUtbytessimulering = false;
            this.commandManager.updateCommand(cmd);
        }

        if (newValue && this.produktId) {
            // newvalue is medIUtbytessimulering
            const cmd = new UpdateProduktionsmallProduktinstruktionCommand(this.produktionsmallGuid, this.handelssortimentId, this.produktId, newValue);
            cmd.medIUtbytessimulering = true;
            this.commandManager.updateCommand(cmd);
        }

        this.medTillUtbytessimulering = newValue;
    }

    produktinstruktionValueFormatter = (item: ProduktionsmallProduktinstruktion) => item && item.id;

    produktinstruktionDisplayValueFormatter = (item: ProduktionsmallProduktinstruktion) => item && item.namnInkPuid;
}

export class ProduktionsmallProduktinstruktion implements IProduktvalRowProduktInstruktion {
    id: number;
    namn: string;
    puid: string;

    get namnInkPuid() {
        return `${this.namn} PUID:  ${this.puid}`;
    }

    constructor(id: number, namn: string, puid: string) {
        this.id = id;
        this.namn = namn;
        this.puid = puid;
    }
}

export interface IProduktionsmall extends ProduktionsmallQueryResponseDTO {
    isNew: boolean;
}

export interface IProduktionsmallRefreshItem {
    mall: IProduktionsmall;
    mode: ProduktionsmallRefreshMode;
}

export class ProduktionsmallRefreshMode {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Save = "Save";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Delete = "Delete";
}
